/* eslint-disable no-undef */
import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import { Border } from "../../Journeys/styles";
import { toast } from "react-toastify";
import { t } from "i18next";
import dayjs from "dayjs";
import { fetchApi } from "../../../utils/methods";
import { EditorContainer, StyledInputV2, StyledLabel, InputContainer } from "../../CreateEvent/style";
import Editor from "../../CKEditor";
import { PostJournalEntry } from "../../../redux/constants/apiConstants";
import { CommonButtonPopup } from "../../ReportsV2/styles";
import { AdminCloseIcon } from "../../../utils/icons";
import { DateWrapper, StyledModal } from "./styles";
import { CustomTitle } from "../../UserDashboard/styles";

const SubmitJournalModal = ({ showModal , onHide, challengeId, selectedDate, fetchJournalData, refreshSelectedDate }) => {

  const [description, setDescription] = useState("");
  const [title, setTitle] = useState(null);
  const [charCount, setCharCount] = useState(0);
  const [isDisabled, setIsDisabled] = useState(false);


  const handleSubmit = async () => {
    // if (!selectedFeeling) {
    //   toast.error("Please select a feeling first!");
    //   return;
    // }

    try {
      const payload = {
        challenge_id: Number(challengeId),
        journal_date:dayjs(selectedDate).format("YYYY-MM-DD"),
        title:title,
        about_the_day:description,
        // task_id: Number(taskId),
      };

      const res = await fetchApi(PostJournalEntry, "POST", payload);

      if (res?.status === "success") {
        toast.success(res?.data?.message || "Journal added successfully!");
        fetchJournalData(challengeId);
        refreshSelectedDate(selectedDate); // ✅ update left card
        onHide();
      } else {
        toast.error(res?.data?.message || "Failed to add Journal");
      }
    } catch (error) {
      console.error("Error submitting Journal:", error);
      toast.error("Something went wrong");
    }
  };

  const onChangeDescription = (evt) => {
    const newContent = evt.getData();
    const trimmedString = newContent.replace(/\s|&nbsp;/g, "");
    trimmedString.length === 0 ||
    trimmedString.length === 7 ||
    trimmedString == "<p></p><p></p>"
      ? setDescription("")
      : setDescription(newContent);

    const plainText = newContent.replace(/<[^>]*>/g, "").trim(); 
    const currentLength = plainText.length;

    setCharCount(currentLength);


  };

  const onChangeTitle = (e) => {
    const value = e.target.value;
    if (value.length > 31) {
      setIsDisabled(true);
      setTitle(value);
    }
    else{
      setIsDisabled(false);
      setTitle(value);
    }
  };
  


  

  // const charCount = description?.replace(/<[^>]*>/g, '')?.replace(/&nbsp;/g, ' ')?.trim().length;

  return (
    <StyledModal isWidth={"800px"} isHeight={"auto"} show={showModal}  onHide={onHide}   style={{marginTop:"100px"}}>
      {/* Header */}
      <Modal.Header style={{ background: "white", border: "none" }}>
        <CustomTitle>
          <div className="headerContainer">
            <span className="title">{t("Ready to Reflect?")}</span>
            <div className="closeImage">
              <div onClick={onHide}>{AdminCloseIcon()}</div>
            </div>
          </div>
        </CustomTitle>
      </Modal.Header>

      <Border
        style={{
          width: "100%",
          background: "#EFEFEF",
          margin: "0px 0px 20px 0",
        }}
      />

      {/* Body */}
      <Modal.Body
        style={{
          display: "flex",
          justifyContent: "center",
          //   alignItems: "center",
          gap: "16px",
          flexDirection:"column",
          width:'100%',
          padding:'0px 24px'
        }}
      >
        <DateWrapper><span className="date">{dayjs(selectedDate).format("MMMM DD, YYYY")}</span></DateWrapper>
        <StyledLabel marginb='0px' margin='0px'>{t("Take a moment to capture your day. Give your entry a title that stands out, and let your thoughts flow.")}</StyledLabel>

        <InputContainer width={"100%"} style={{marginRight:'0px'}}>
          <StyledLabel margin='0px'>{t("Give it a title")}{<span>*</span>}</StyledLabel>
          <StyledInputV2
            placeholder={"Enter title"}
            name="title"
            onChange={onChangeTitle}
            value={title}
            maxLength="50"
          />
          <div
            className="count"
            style={{
              color: isDisabled ? "#DA6C74" : "#BDBDBD"
            }}
          >{title?.length || 0}/30 | C</div>
        </InputContainer>

        <StyledLabel margin='0px' marginb='0px' isFont={"14px"} style={{ marginTop: "0px" }} color={"#184A61"}>{t("Write about your day")}{<span>*</span>}</StyledLabel>
        <InputContainer isColorError={charCount > 300}  width={"100%"} style={{marginRight:'0px'}}>
          <EditorContainer>
            <Editor
              content={description}
              onChange={onChangeDescription}
              placeholder={"Share your wins, challenges, or anything that inspired you today."}
            />
          </EditorContainer>
          <div className="char-count">{charCount}/300 | C</div>
          {/* <div className="char-count">{parse(description)?.[0]?.props?.children?.[0]?.length || 0}/300 | C</div> */}
        </InputContainer>
      </Modal.Body>

      {/* Footer */}
      <Modal.Footer
        style={{
          borderTop: "none",
          display: "flex",
          justifyContent: "center",
          width: "100%",
        }}
      >
        <CommonButtonPopup
          height="48px"
          width="200px"
          onClick={handleSubmit}
          disabled={!description || !title || isDisabled || description?.replace(/<[^>]*>/g, '')?.replace(/&nbsp;/g, ' ')?.trim().length > 300}
        >
          {t("Save")}
        </CommonButtonPopup>
      </Modal.Footer>
    </StyledModal>
  );
};

SubmitJournalModal.propTypes = {
  showModal: PropTypes.bool.isRequired,
  refreshSelectedDate: PropTypes.func,
  onHide: PropTypes.func.isRequired,
  challengeId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  selectedDate:PropTypes.string,
  fetchJournalData:PropTypes.func
};

export default withTranslation()(SubmitJournalModal);
